import { apiSlice } from "../api/apiSlice";

const usersSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUser: builder.query({
            query: (email) => `/users?email=${email}`
        })
    })
})


export const {useGetUserQuery} = usersSlice